import bowser from 'bowser';

export default function () {
    document.body.classList.add('is-loaded');
    if (typeof bowser === 'undefined') {
        return;
    }
    if (bowser.name) {
        document.body.classList.add(bowser.name.replace(/\s+/g, '-').toLowerCase());
    }
    if (bowser.version) {
        const name = bowser.name.replace(/\s+/g, '-').toLowerCase();
        const version = bowser.version.replace(/\s+/g, '-').toLowerCase();
        document.body.classList.add(name + '-' + version);
    }
}
